import { HttpClient, HttpHeaders } from '@angular/common/http';
import { stringify } from '@angular/compiler/src/util';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, shareReplay, take, tap } from 'rxjs/operators';
import { Department } from '@ui-components/models';
// import { EAuthorizationType } from '../models/intranet/general-enums';
import { BaseResponse } from './base-response';
import { DataSourcesService } from './data-sources.service';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsDataService {

  private departmentsDataSubject = new BehaviorSubject<Department[]>([]);
  departments$: Observable<Department[]> = this.departmentsDataSubject.asObservable();

  constructor(private http: HttpClient, private dataSourcesService: DataSourcesService) { }

  getDepartments(apiId) {
    let arr = [];
    this.departments$.pipe(take(1)).subscribe((res) => (arr = res));
    if (arr && arr.length > 0) {
      return;
    }
    let data = {
      ID: "1",
      CRG_COM_ID: "1",
      inputType: ["ID", "CRG_COM_ID"],

    };
    return this.dataSourcesService.invokeDataSource(apiId, data)
      .pipe(
        // tap((res: BaseResponse<Department[]>) => {
        //   if (res.message) {
        //     console.log(res.message.length > 0);
        //     return of({ Data: [] });
        //   }
        // }),
        // tap((res)=>console.log(res,'sasd')),
        map((res) => res.content),
        tap((res: Department[]) => this.departmentsDataSubject.next(res)),
        shareReplay(1)
      );
  }
  public getAllDepartments() {
    return this.http.get<BaseResponse<any>>(`/DocumentLoockups/GetAllDepartments`);
  }

  public getAllSharedDepartments() {
    return this.http.get<BaseResponse<any>>(`/Department/GetAllDepartments`);
  }
}
